<span class="input-length" *ngIf="!control.disabled">
  {{control?.value?.length || 0}}<ng-container *ngIf="max">/{{max}}</ng-container>
</span>
